import { render } from "./ShoppingListAppendIngredientPage.vue?vue&type=template&id=b9e24ad2&scoped=true&ts=true"
import script from "./ShoppingListAppendIngredientPage.vue?vue&type=script&lang=ts"
export * from "./ShoppingListAppendIngredientPage.vue?vue&type=script&lang=ts"

import "./ShoppingListAppendIngredientPage.vue?vue&type=style&index=0&id=b9e24ad2&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e24ad2"]])

export default __exports__